type VeterinarioForm = {
  nombre: string;
  apellido: string;
  email: string;
  telefono: string;
  fechaAtencion: string;
};

export const getEmptyVeterinarioForm = (): VeterinarioForm => ({
  nombre: '',
  apellido: '',
  email: '',
  telefono: '',
  fechaAtencion: '',
});

type VeterinarioRes = {
  nombre: string;
  apellido: string;
  mail?: string;
  telefono: string;
  domicilio: string;
  especialidad: string;
  horario_contacto: string;
  id: number;
  matricula: string;
  colegio: string;
  tipo: string;
};

type Veterinario_VFLD = {
  nombre: string;
  mail: string;
  telefono: string;
  tipo: string;
};

type Derivacion = {
  // id: number;
  // tipo: string;
};

type VetFormLinkData = {
  siniestroId: string;
  veterinario: Veterinario_VFLD;
  fechaAtencion: string;
  derivaciones: Derivacion[];
};

export type { VeterinarioForm, VeterinarioRes, VetFormLinkData };
